/*
 * Listicle landing page behaviour.
 *
 * Two custom elements:
 *   <listicle-countdown>  — the "Your Savings Reserved For 09:55" timer
 *   <listicle-offer>      — one-time vs Subscribe & Save selection
 *
 * The surrounding <product-form> (theme.js) owns the actual add-to-cart
 * request; this file only keeps the form's hidden inputs in sync.
 */

class ListicleCountdown extends HTMLElement {
  connectedCallback() {
    this.output = this.querySelector('[data-countdown-output]');
    if (!this.output) return;

    const minutes = parseInt(this.getAttribute('minutes'), 10);
    this.duration = (Number.isFinite(minutes) ? minutes : 10) * 60 * 1000;
    this.storageKey = `listicle:countdown:${this.getAttribute('key') || 'default'}`;

    // Persist the deadline so the timer doesn't restart on every navigation.
    let deadline = parseInt(sessionStorage.getItem(this.storageKey), 10);
    if (!Number.isFinite(deadline) || deadline < Date.now()) {
      deadline = Date.now() + this.duration;
      try {
        sessionStorage.setItem(this.storageKey, String(deadline));
      } catch (e) {
        // Private browsing — the timer still works, it just won't persist.
      }
    }
    this.deadline = deadline;

    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  tick() {
    const remaining = Math.max(0, this.deadline - Date.now());
    const total = Math.floor(remaining / 1000);
    const mm = String(Math.floor(total / 60)).padStart(2, '0');
    const ss = String(total % 60).padStart(2, '0');
    this.output.textContent = `${mm}:${ss}`;

    if (remaining === 0) clearInterval(this.timer);
  }
}

if (!customElements.get('listicle-countdown')) {
  customElements.define('listicle-countdown', ListicleCountdown);
}

class ListicleOffer extends HTMLElement {
  connectedCallback() {
    this.sellingPlanInput = this.querySelector('[data-selling-plan-input]');
    this.radios = Array.from(this.querySelectorAll('[data-plan-radio]'));
    if (!this.radios.length) return;

    this.onChange = this.onChange.bind(this);
    this.radios.forEach((radio) => radio.addEventListener('change', this.onChange));

    this.sync();
  }

  disconnectedCallback() {
    this.radios.forEach((radio) => radio.removeEventListener('change', this.onChange));
  }

  onChange() {
    this.sync();
  }

  sync() {
    const selected = this.radios.find((radio) => radio.checked) || this.radios[0];
    if (!selected) return;

    const plan = selected.dataset.sellingPlan || '';

    if (this.sellingPlanInput) {
      this.sellingPlanInput.value = plan;
      // Shopify rejects an empty selling_plan param, so drop it entirely for
      // the one-time option rather than submitting a blank value.
      this.sellingPlanInput.disabled = plan === '';
    }

    const variant = selected.dataset.variantId;
    const idInput = this.querySelector('[data-variant-input]');
    if (variant && idInput) idInput.value = variant;
  }
}

if (!customElements.get('listicle-offer')) {
  customElements.define('listicle-offer', ListicleOffer);
}
